import React from 'react';
import PropTypes from 'prop-types';

// Utils
import cn from '../../../utils/tools/cn';

import styles from './PageSection.module.scss';

function PageSection({
  titleRef, sectionRef, title, icon, children,
}) {
  return (
    <div ref={sectionRef} className={cn([styles.section, 'm-b-30 p-b-30'])}>
      {title ? (
        <h2 ref={titleRef} className={cn([styles.title, 'd-flex a-center'])}>
          {icon ? (
            <span className={cn([styles.icon, 'd-flex center m-r-10'])}>{icon}</span>
          ) : null}
          <span className="font-secondary fs-24 fw-500 c-neutral-01">{title}</span>
        </h2>
      ) : <div ref={titleRef} />}

      <div className={cn([styles.block, 'm-t-10'])}>
        {children}
      </div>
    </div>
  );
}

PageSection.propTypes = {
  titleRef: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
  sectionRef: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
  title: PropTypes.string,
  icon: PropTypes.node,
  children: PropTypes.node,
};

PageSection.defaultProps = {
  titleRef: null,
  sectionRef: null,
  title: null,
  icon: null,
  children: null,
};

export default PageSection;
